import api from "config/axios";

export const getCompositionList = () => api.get("/compositions");
